import angular from 'angular'
import 'ngreact'
import '../fonts'
import '../styles'
import '../sass/main.scss'
import './_index.scss'

import { sharedReactStateModuleName } from './ng/shared-react-state'
import { reactSensitiveRedactedDataTooltip } from './ng/components/sensitive-data/redacted-data-tooltip'

export const sharedModule = angular.module('contrast.react.shared', [
  reactSensitiveRedactedDataTooltip,
  sharedReactStateModuleName
]).name
